module.exports = __webpack_public_path__ + "static/processing-hero-100-77a7005ff3a758613e78127b839dffb5.jpg";